import React, { useState } from "react";
import { Container, Row, Col, Card, ButtonGroup, Button, InputGroup, Form, Badge } from "react-bootstrap";
import LevelCard from "../../components/LevelCard/LevelCard";
import avatar from "../../assets/images/avtar-male.png"
import LoginImg from "../../assets/images/vfr.jpg"
import { Line } from "react-chartjs-2";
import { FaPen, FaSearch } from "react-icons/fa";
const Profile = () => {
    const [image, setImage] = useState<string>(avatar);
      
        const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            setImage(URL.createObjectURL(file)); // Show image preview
          }
        };
    return (
        <Container className="d-flex flex-column align-items-center py-4">
<Card className="col-lg-6" style={{ background: "#f8f9fb" }}>
      <Card.Body className="bg-white rounded-4 p-4">
        {/* Top Row: Badge + Price */}
        <Row className="align-items-start">
          <Col xs={6}>
            <Badge bg="warning" text="white" className="mb-2 px-3 py-2 rounded-pill">
              Current Plan
            </Badge>
          </Col>
          <Col xs={6} className="text-end fw-bold" style={{ color: "#00A693", fontSize: "1.4rem" }}>
            €480
          </Col>
        </Row>

        {/* Product Row */}
        <Row className="align-items-center mt-2">
          <Col xs={3} md={2}>
          <img src={LoginImg} className="login-img" alt="" style={{ height: "75px" }} />
          
          </Col>
          <Col xs={9} md={10}>
            <h4 className="fw-bold mb-1">VFR</h4>
            <div>
              <span className="fw-bold" style={{ color: "#00A693", fontSize: "1.2rem" }}>
                €280
              </span>
              <small className="text-muted">/6 month, billed annually</small>
            </div>
            <small className="text-muted">(excluding Professional Services):</small>
          </Col>
        </Row>

        {/* Description */}
        <p className="mt-3">
          Get unlimited access to all VFR training modules for six months. 
          Practice real-world flight communication with an interactive AI simulator 
          and build the confidence you need to handle radio calls effectively.
        </p>

        {/* Expiry Date + Renew */}
        <Row className="align-items-center mb-3 d-lg-flex">
          <div>
            <span className="text-muted">Expiry Date </span>
            <span className="fw-bold" style={{ color: "#e74c3c" }}>
              24 June 2025
            </span>
          </div>
          
        </Row>

        <hr />

        {/* Upgrade Plan Button */}
        <div className="text-center">
          <Button variant="success" className="px-5 py-2 rounded-3 btn-brand-1 mb-2">
            Upgrade Plan
          </Button>
          <br></br>  
          <a href="#renew" className=" text-decoration-underline text-dark text-lg-end text-start">
              Renew
            </a> →
        </div>
      </Card.Body>
    </Card>
    </Container>
    );
};

export default Profile;